/**
 * The Background mode enumeration.
 */
export enum BackgroundMode {
  /* Solid color. */
  SolidColor,
  /* Sky. */
  Sky,
  /** Texture */
  Texture
}
